import React from "react";
import Page from "components/LayoutComponents/Page";
import Helmet from "react-helmet";
import Dashboard from "./Dashboard";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import { UserPermission } from "../../config";
import build from "redux-object";
import TermsConditionsModal from "../../components/LayoutComponents/TermsConditions";
import {
  loadPatientsRequest,
  loadActiveAccountRequest,
  loadDashboardRequest
} from "ducks/data";
import { savePatientRequest } from "ducks/patient";
import { setActiveDialog, logout } from "ducks/app";
import { makeGetAccount, makeGetDashboard } from "selectors/data";
import Permissions from "../../components/LayoutComponents/Permissions";
import EmptyState from "../Patient/EmptyState";

const makeMapStateToProps = () => {
  const getAccount = makeGetAccount();
  const getDashboard = makeGetDashboard();
  const mapStateToProps = (state, props) => {
    let dashboard = getDashboard(state, props);
    return {
      isLoading: state.data.loadingPatients,
      activeDialog: state.app.activeDialog,
      patients:
        dashboard && dashboard.attributes
          ? dashboard.attributes.patientReview
          : [],
      account: state.data.accounts ? getAccount(state, props) : {},
      user: dashboard ? dashboard : state.app.userState
    };
  };
  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadActiveAccountRequest,
      loadPatientsRequest,
      savePatientRequest,
      loadDashboardRequest,
      setActiveDialog,
      push,
      logout
    },
    dispatch
  );

class DashboardPage extends React.Component {
  static defaultProps = {
    pathName: "Dashboard",
    roles: ["CLINICIAN", "ACCOUNT_ADMIN", "SUPER_ADMIN", "GUEST"]
  };
  componentDidMount() {
    this.props.setActiveDialog("term-conditions");

    this.props.loadActiveAccountRequest();
    this.props.loadDashboardRequest();
  }
  render() {
    const props = this.props;

    return (
      <Page {...props}>
        <Helmet title="Dashboard" />
        <TermsConditionsModal
          account={this.props.account}
          show={this.props.activeDialog === "term-conditions"}
          onCancel={() => {
            this.props.setActiveDialog();
            this.props.logout();
          }}
          onConfirm={() => this.props.setActiveDialog()}
        />
        <div className="d-flex align-items-center">
          <h1 className="mb-0 mr-2"> Dashboard</h1>
        </div>
        <Permissions
          roles={[UserPermission.Clinician, UserPermission.AccountAdmin]}
        >
          <Dashboard {...this.props} />
        </Permissions>
        <Permissions roles={["GUEST"]}>
          <div className="shadow-small">
            <EmptyState
              name="Guest Account"
              icon="patient"
              description={
                <div>
                  This is a GUEST account. It is a restricted account.
                  <br />
                  You have access to a subset of our patients.
                </div>
              }
            />
          </div>
        </Permissions>
        <Permissions roles={["SUPER_ADMIN"]}>
          <div className="shadow-small">
            <EmptyState
              name="Restricted Access"
              icon="essential"
              description={
                <div>
                  This is a SUPER ADMIN account to manage accounts.
                  <br />
                  Log in as the account admin to manage account specific data.
                </div>
              }
            />
          </div>
        </Permissions>
      </Page>
    );
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(DashboardPage);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js